import * as o from "react";
import a from "../lib/IconBase.es.js";
import t from "../defs/BookmarkSimple.es.js";
const m = o.forwardRef((e, r) => /* @__PURE__ */ o.createElement(a, { ref: r, ...e, weights: t }));
m.displayName = "BookmarkSimpleIcon";
const c = m;
export {
  c as BookmarkSimple,
  m as BookmarkSimpleIcon
};
